import React, { useState, useEffect } from 'react';
import './css/DigitalClockPreview.css';
import './css/DigitalClock.css';
import { useSelector } from 'react-redux';

const CornerDigitalClock = ({ area, dimensions, timestamp, previewMode = false }) => {
    const [time, setTime] = useState(new Date(timestamp * 1000));
    const [showColon, setShowColon] = useState(true);
    const { clockSettings, clockDisplay } = useSelector((state) => state.apps);

    const [areaHpx, setAreaHpx] = useState();
    const [areaWpx, setAreaWpx] = useState();
    const [Corner, setCorner] = useState(false);
    useEffect(() => {
        if (previewMode) {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        } else {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        }
    }, [area]);

    useEffect(() => {
        if (clockDisplay == "CORNER") {
            setCorner(true);
        }
    }, [clockDisplay]);

    useEffect(() => {
        if (timestamp) {
            const baseTime = new Date(timestamp * 1000);
            setTime(baseTime);
        }
    }, [timestamp]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(prev => new Date(prev.getTime() + 1000));
            setShowColon(prev => !prev);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const formatTime = (val) => (val < 10 ? `0${val}` : val.toString());
    const getFormattedHours = () => {
        let hours = time.getUTCHours();
        if (clockSettings.timeFormat == '12') {
            hours = hours % 12 || 12;
        }
        return formatTime(hours);
    };

    const hours = getFormattedHours();
    const minutes = formatTime(time.getMinutes());
    const month = formatTime(time.getMonth() + 1);
    const day = formatTime(time.getDate());
    const weekdayIndex = time.getDay();
    const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];


    const clockContainer = previewMode ? 'preview-digital-clock-container' : `digital-clock-container`;
    const dateInfoClock = previewMode ? 'preview-digital-date-info-clock' : `digital-date-info-clock`;
    const labelClock = previewMode ? 'preview-digital-label-clock' : `digital-label-clock`;
    const valueClock = previewMode ? 'preview-digital-value-clock' : `digital-value-clock`;
    const timeInfoClock = previewMode ? 'preview-digital-time-info-clock' : `digital-time-info-clock`;
    const timeClock = previewMode ? 'preview-digital-time-clock' : `digital-time-clock`;
    const timeBgClockHr0 = previewMode ? 'preview-digital-time-bg-clock-hr0' : `digital-time-bg-clock-hr0`;
    const timeBgClockHr1 = previewMode ? 'preview-digital-time-bg-clock-hr1' : `digital-time-bg-clock-hr1`;
    const timeBgClockMn0 = previewMode ? 'preview-digital-time-bg-clock-mn0' : `digital-time-bg-clock-mn0`;
    const timeBgClockMn1 = previewMode ? 'preview-digital-time-bg-clock-mn1' : `digital-time-bg-clock-mn1`;

    const colonClock = previewMode ? 'preview-digital-colon-bg-clock' : `digital-colon-bg-clock`;

    const timeActiveClockHr0 = previewMode ? 'preview-digital-time-active-clock-hr0' : `digital-time-active-clock-hr0`;
    const timeActiveClockHr1 = previewMode ? 'preview-digital-time-active-clock-hr1' : `digital-time-active-clock-hr1`;
    const timeActiveClockMn0 = previewMode ? 'preview-digital-time-active-clock-mn0' : `digital-time-active-clock-mn0`;
    const timeActiveClockMn1 = previewMode ? 'preview-digital-time-active-clock-mn1' : `digital-time-active-clock-mn1`;

    const weekdaysClock = previewMode ? 'preview-digital-weekdays-clock' : `digital-weekdays-clock`;





    return (
        <div className={`${clockContainer}`} style={{
            backgroundColor: Corner ? 'transparent' : "white",
        }}>
            <div className={dateInfoClock}   >
                <div className={labelClock} style={{
                    fontSize: `${Math.min(areaWpx * 0.025, areaHpx * 0.13)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.025, areaHpx * 0.13)}px`,
                }}>MONTH</div>
                <div className={valueClock} style={{
                    fontSize: `${Math.min(areaWpx * 0.06, areaHpx * 0.23)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.06, areaHpx * 0.23)}px`,
                }}>{month}</div>
                <div className={labelClock} style={{
                    fontSize: `${Math.min(areaWpx * 0.025, areaHpx * 0.13)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.025, areaHpx * 0.13)}px`,
                }}>DAY</div>
                <div className={valueClock} style={{
                    fontSize: `${Math.min(areaWpx * 0.06, areaHpx * 0.23)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.06, areaHpx * 0.23)}px`,
                }}>{day}</div>
            </div>

            <div className={timeInfoClock}>
                <div className={timeClock} style={{
                    lineHeight: `${Math.min(areaWpx * 0.15, areaHpx * 0.45)}px`,
                    fontSize: `${Math.min(areaWpx * 0.15, areaHpx * 0.45)}px`
                }}>
                    {/* Background "00:00" (dimmed) */}
                    <span className={timeBgClockHr0}>0</span>
                    <span className={timeBgClockHr1}>0</span>

                    <span className={colonClock}>:</span>
                    <span className={timeBgClockMn0}>0</span>
                    <span className={timeBgClockMn1}>0</span>


                    {/* Active time (bright) */}
                    <span className={timeActiveClockHr0}>{hours[0]}</span>
                    <span className={timeActiveClockHr1}>{hours[1]}</span>

                    <span className={`colon ${showColon ? 'visible-clock' : 'invisible-clock'}`}>:</span>
                    <span className={timeActiveClockMn0}>{minutes[0]}</span>
                    <span className={timeActiveClockMn1}>{minutes[1]}</span>

                </div>

                <div className={weekdaysClock}  >
                    {weekDays.map((day, i) => (
                        <span
                            key={i}
                            style={{
                                fontSize: `${Math.min(areaWpx * 0.03, areaHpx * 0.13)}px`
                            }}
                            className={`${weekdaysClock} ${i === weekdayIndex ? 'active-clock' : ''}`}
                        >
                            {day}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CornerDigitalClock;
